import * as React from 'react';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import useStyles from './use_styles';
import { toastContainerPropTypes } from './prop_types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ToastContainer = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    children,
    newOnTop = true,
    position = 'bottom'
  } = _ref;
  var styles = useStyles({
    newOnTop,
    position
  });
  return ___EmotionJSX("div", {
    css: styles,
    ref: ref
  }, ___EmotionJSX(TransitionGroup, {
    component: null
  }, children));
});
ToastContainer.propTypes = toastContainerPropTypes;
ToastContainer.displayName = 'ToastContainer';
export default ToastContainer;